<script setup lang="ts">
// import SwitchButton from '@/components/basicComponents/SwitchButton.vue'
import { storeToRefs } from 'pinia'
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
  VisuallyHidden,
} from 'reka-ui'
import { useAuthStore } from '@/stores/auth'
import { ref } from 'vue'
import UserIcon from '@/assets/Icons/UserIcon.svg'
import CloseIcon14 from '@/assets/Icons/CloseIcon14.svg'
import LogoutIcon from '@/assets/Icons/LogoutIcon.svg'
import HSeparator from '@/components/HSeparator.vue'
import LinkButton from '@/components/LinkButton.vue'
import { useRouter } from 'vue-router'

defineProps<{
  teleportTarget: string
}>()

const router = useRouter()
const isOpen = ref(false)

const authStore = useAuthStore()
const { user } = storeToRefs(authStore)

function navigateToUserPreferences() {
  isOpen.value = false
  router.push({ name: 'userPreferences' })
}
</script>

<template>
  <DialogRoot v-model:open="isOpen">
    <DialogTrigger class="dialog-trigger"><UserIcon /></DialogTrigger>
    <DialogPortal :to="teleportTarget">
      <DialogOverlay class="dialog-overlay" />
      <DialogContent class="dialog-content">
        <div class="header">
          <DialogTitle class="header-title">
            {{ user?.attributes?.email }}
          </DialogTitle>
          <DialogClose class="close-button">
            <CloseIcon14 />
          </DialogClose>
        </div>
        <HSeparator />
        <div class="user-action-list">
          <button class="user-action" @click="navigateToUserPreferences">{{ $t('header.userDialog.userPreferences') }}</button>
        </div>
        <HSeparator />
        <LinkButton class="logout-button" :icon="LogoutIcon" @click="authStore.logout">{{ $t('header.userDialog.logout') }}</LinkButton>
        <VisuallyHidden asChild>
          <DialogDescription>{{ $t('header.userDialog.accesibility.description') }}</DialogDescription>
        </VisuallyHidden>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>

<style lang="scss" scoped>
.dialog-trigger {
  background-color: transparent;
  border: none;
  border-radius: 0;
  padding: 8px;
}

.dialog-overlay {
  position: fixed;
  inset: 0;
}

.dialog-content {
  position: absolute;
  top: calc(100% + 1px);
  right: 0;
  min-width: 240px;
  max-width: 100%;
  padding: 12px;
  background-color: var(--ullib-color-contrast);
  border-radius: 4px;
  box-shadow: 0px 0px 8px var(--ullib-color-shadow);
  display: flex;
  flex-direction: column;
  z-index: 2;
}
.dialog-content:focus {
  outline: none;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 31px;
  width: 100%;
}

.header-title {
  color: var(--ullib-color-accent-1);
  font-size: var(--ullib-size-font-normal);
  line-height: var(--ullib-size-line-spacing-normal);
  font-weight: 400;
  align-self: start;
}

.close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: transparent;
  border: none;
  //TODO - hover
}

.user-action-list {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
}

.user-action {
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0 12px;
  cursor: pointer;

  &:hover {
    background-color: var(--ullib-color-hover);
  }

  &:active {
    background-color: var(--ullib-color-hover-strong);
  }
}

.logout-button {
  display: flex;
  justify-content: center;
  min-width: 120px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-left: auto;
  margin-right: auto;
}
</style>
